import { Box, Button, Typography, useTheme } from "@mui/material";
import { InlineIcon } from "@iconify/react";
import { OcRoleFilterItemData } from "oc/components/role-filter";

interface OcRoleFilterSubtypeRemovableItemsProps {
  selectedItems: OcRoleFilterItemData[];
  handleClickItem: (item: OcRoleFilterItemData) => void;
  generateLabel: (item: OcRoleFilterItemData) => string;
}
export const OcRoleFilterSubtypeRemovableItems: React.FC<
  OcRoleFilterSubtypeRemovableItemsProps
> = ({ selectedItems, handleClickItem, generateLabel }) => {
  const theme = useTheme();
  if (selectedItems.length === 0) return null;

  return (
    <Box
      sx={{
        padding: "16px 8px 0px",
        display: "block",
        maxHeight: "180px",
        overflowY: "auto",
        flexGrow: 1,
      }}
    >
      {selectedItems.map((item) => {
        return (
          <Button
            key={item._id}
            variant="text"
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              textTransform: "none",
              minHeight: "32px",
              height: "auto",
              padding: "4px 8px",
              color: theme.palette.darkBase.main,
              "&.MuiButton-textPrimary:hover": {
                color: theme.palette.darkBase.main,
                backgroundColor: "#0000000a",
              },
            }}
            onClick={() => {
              handleClickItem(item);
            }}
          >
            <Typography component="span" textAlign="left">
              {generateLabel(item)}
            </Typography>
            <InlineIcon icon="mdi:minus-thick" height="12px" />
          </Button>
        );
      })}
    </Box>
  );
};
